import { FC } from 'react';
import InfoIcon from '../../../elements/InfoIcon/InfoIcon';
import Section, { SectionProps } from './Section';

const InfoIconSection: FC<React.PropsWithChildren<InfoIconSectionProps>> = ({
  labelIcon,
  ...sectionProps
}) => {
  return (
    <Section {...sectionProps} labelIcon={<InfoIcon title={labelIcon} />} />
  );
};

export interface InfoIconSectionProps extends Omit<SectionProps, 'labelIcon'> {
  labelIcon: string;
}

export default InfoIconSection;
